import { useContext, useRef } from 'react';
import { UserSessionContext } from 'providers/UserSessionProvider';

const RedirectNotification = () => {
  const { locale } = useContext(UserSessionContext);
  const notification = useRef();

  return (
    <div ref={notification} className="redirect-notification-container">
      <div className="redirect-notification">
        <div>
          <p>Te hemos redirigido al acceso directo de la plataforma Smart Charging.</p>
          <p>
            Si en el futuro quieres ahorrarte este paso, puedes ingresar directamente a{' '}
            <a href={window.location.host}>{window.location.host}</a> con tu email.
          </p>
        </div>
        <button
          type="button"
          className="ml-4"
          onClick={() => {
            notification.current.classList.add('hidden');
          }}
        >
          {locale === 'es' ? 'ACEPTAR' : 'ACCEPT'}
        </button>
      </div>
    </div>
  );
};

export default RedirectNotification;
